import RelatedRecord from './component';
import { RelatedRecordProps } from './types';

export default RelatedRecord;
export type { RelatedRecordProps };
